export default __webpack_public_path__ + "static/media/banner1.12806184.jpg";